import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { Route, Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    minWidth: 0, // So the Typography noWrap works
  },
  toolbar: theme.mixins.toolbar,
});

export const PublicRoute = ({ isAuthenticated, component: Component, ...rest }) => {
  const { classes } = {...rest};
  return (
  <Route
    {...rest}
    component={(props) => (
    isAuthenticated ? (
        <Redirect to="/cashier" />
    ) : (
      <div className={classes.root}>
        <AppBar position="absolute" className={classes.appBar}>
          <Toolbar>
            <Typography variant="title" color="inherit" noWrap>
              Petty Cash
            </Typography>
          </Toolbar>
        </AppBar>
        <main className={classes.content}>
          <div className={classes.toolbar} />
            <Component {...props} />
        </main>
      </div>
    )
  )}
  />
)};

const mapStateToProps = (state) => {
  return ({
  isAuthenticated: !!state.auth.uid
  });
};

export default compose(
  withStyles(styles, {
    name: 'PublicRoute',
  }), connect(mapStateToProps))(PublicRoute);



// WEBPACK FOOTER //
// ./src/routers/PublicRoute.js